import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { Accordion, alpha, styled } from '@mui/material';

const StyledAccordion = styled(Accordion)({
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',

  '&.Mui-expanded': {
    margin: '4px 0px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    '& .MuiAccordionDetails-root': {
      borderTop: `1px solid ${alpha(spaceCadet[300], 0.5)}`,
    },
  },

  '& .MuiAccordionSummary-content': {
    margin: '8px 0px',
    '&.Mui-expanded': {
      margin: '12px 0px',
    },
  },

  '& .MuiAccordionSummary-root': {
    minHeight: 0,
    color: spaceCadet[800],
    fontSize: 14,
    lineHeight: '20px',
  },

  '& .MuiAccordionDetails-root': {
    '& strong': {
      fontWeight: 600,
    },

    '& .MuiTypography-caption': {
      backgroundColor: alpha(ultraMarine[300], 0.3),
      border: `0px solid ${alpha(ultraMarine[300], 0.8)}`,
      borderLeftWidth: 4,
      fontSize: 14,
      lineHeight: '20px',
      padding: '4px 16px',
      margin: '8px -16px -16px -16px',
    },
  },

});

export default StyledAccordion;
